import { Link, Outlet } from "react-router-dom";
import { Activity, LogOut, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Toaster } from "@/components/ui/sonner";
import { CacheMenu } from "@/components/layout/cache-menu";
import { ThemeToggle } from "@/components/theme-toggle";
import { useAuth } from "@/lib/auth/use-auth";

export function AppShell() {
  const { isAuthenticated, signOut } = useAuth();

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <header className="border-b bg-card/60 backdrop-blur sticky top-0 z-40">
        <div className="container mx-auto flex items-center justify-between gap-4 px-4 h-14">
          <Link to="/" className="flex items-center gap-2 font-semibold">
            <Activity className="size-5 text-primary" />
            <span>GitHub Actions Usage Analyzer</span>
          </Link>
          <div className="flex items-center gap-2 text-sm">
            <span
              className="hidden md:inline-flex items-center gap-1 text-muted-foreground"
              title="Your token stays in your browser; repo data never transits a server"
            >
              <ShieldCheck className="size-4" />
              Privacy-first
            </span>
            <Separator orientation="vertical" className="h-6" />
            <ThemeToggle />
            {isAuthenticated ? <CacheMenu /> : null}
            {isAuthenticated ? (
              <Button variant="ghost" size="sm" onClick={signOut}>
                <LogOut className="size-4 mr-2" />
                Sign out
              </Button>
            ) : null}
          </div>
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t py-4 text-center text-xs text-muted-foreground">
        Token stored in sessionStorage. Repo data flows directly from your browser to
        api.github.com.
      </footer>
      {/* Toast notifications — position top-right */}
      <Toaster position="top-right" />
    </div>
  );
}
